import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=3995e8f6&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=ts&"
export * from "./Navbar.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/sass/_navbar.scss?vue&type=style&index=0&id=3995e8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995e8f6",
  null
  
)

component.options.__file = "Navbar.vue"
export default component.exports